"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import AdvertisePopup from "./AdvertisePopup";
import { useAdSlot } from "./AdDataProvider";
import { useDevice } from '@/contexts/DeviceContext';
import { isLighthouseClient } from '@/lib/isLighthouse';
interface SectionBottomAdProps {
  slot: "section-bottom1" | "section-bottom2" | "article-bottom1" | "article-bottom";
  className?: string;
}

// Reserved dimensions by slot — matches common banner ad sizes (728x90 / 320x100 mobile)
// Reserving space before ad loads prevents CLS
const SLOT_DIMENSIONS: Record<string, {
  desktop: {
    w: number;
    h: number;
  };
  mobile: {
    w: number;
    h: number;
  };
}> = {
  "section-bottom1": {
    desktop: {
      w: 728,
      h: 90
    },
    mobile: {
      w: 320,
      h: 100
    }
  },
  "section-bottom2": {
    desktop: {
      w: 728,
      h: 90
    },
    mobile: {
      w: 320,
      h: 100
    }
  },
  "article-bottom1": {
    desktop: {
      w: 300,
      h: 250
    },
    mobile: {
      w: 300,
      h: 250
    }
  },
  "article-bottom": {
    desktop: {
      w: 728,
      h: 90
    },
    mobile: {
      w: 320,
      h: 100
    }
  }
};
export default function SectionBottomAd(t0) {
  const $ = _c(26);
  const {
    slot,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const adContentRef = useRef(null);
  const [adCode, setAdCode] = useState(null);
  const [adInjected, setAdInjected] = useState(false);
  const {
    isMobile,
    deviceDetected
  } = useDevice();
  const adSlotData = useAdSlot(slot);
  let t2;
  let t3;
  if ($[0] !== adSlotData || $[1] !== deviceDetected || $[2] !== isMobile) {
    t2 = () => {
      if (deviceDetected && adSlotData) {
        setAdCode(isMobile ? adSlotData.mobileAdCode || adSlotData.desktopAdCode : adSlotData.desktopAdCode);
      }
    };
    t3 = [adSlotData, isMobile, deviceDetected];
    $[0] = adSlotData;
    $[1] = deviceDetected;
    $[2] = isMobile;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== adCode || $[6] !== deviceDetected) {
    t4 = () => {
      if (!deviceDetected || !adCode || !adContentRef.current || isLighthouseClient()) {
        return;
      }
      let cleanedCode = adCode.trim();
      if (cleanedCode.startsWith("\"") && cleanedCode.endsWith("\"")) {
        cleanedCode = cleanedCode.slice(1, -1);
      }
      cleanedCode = cleanedCode.replace(/\\""/g, "\"").replace(/\\n/g, "\n").replace(/\\t/g, "\t").replace(/""/g, "\"");
      adContentRef.current.innerHTML = cleanedCode;
      const scripts = adContentRef.current.querySelectorAll("script");
      scripts.forEach(_temp);
      setAdInjected(true);
    };
    $[5] = adCode;
    $[6] = deviceDetected;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== adCode) {
    t5 = [adCode];
    $[8] = adCode;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
  const dims = SLOT_DIMENSIONS[slot];
  const reservedW = isMobile ? dims.mobile.w : dims.desktop.w;
  const reservedH = isMobile ? dims.mobile.h : dims.desktop.h;
  const t6 = `flex justify-center ${className}`;
  const t7 = adInjected ? "auto" : reservedW + 10;
  const t8 = reservedW + 10;
  const t9 = reservedH + 10;
  let t10;
  if ($[10] !== t7 || $[11] !== t8 || $[12] !== t9) {
    t10 = {
      width: t7,
      minWidth: t8,
      height: t9
    };
    $[10] = t7;
    $[11] = t8;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  const t11 = adInjected ? "auto" : reservedW;
  let t12;
  if ($[14] !== reservedH || $[15] !== t11) {
    t12 = <div ref={adContentRef} style={{
      width: t11,
      height: reservedH
    }} />;
    $[14] = reservedH;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] !== adCode) {
    t13 = adCode && <AdvertisePopup />;
    $[17] = adCode;
    $[18] = t13;
  } else {
    t13 = $[18];
  }
  let t14;
  if ($[19] !== t10 || $[20] !== t12 || $[21] !== t13) {
    t14 = <div className="m-[5px]"><div className="bg-gray-100 p-[5px] relative" style={t10}>{t12}{t13}</div></div>;
    $[19] = t10;
    $[20] = t12;
    $[21] = t13;
    $[22] = t14;
  } else {
    t14 = $[22];
  }
  let t15;
  if ($[23] !== t14 || $[24] !== t6) {
    t15 = <div className={t6}>{t14}</div>;
    $[23] = t14;
    $[24] = t6;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  return t15;
}
function _temp(script) {
  const newScript = document.createElement("script");
  Array.from(script.attributes).forEach(attr => {
    newScript.setAttribute(attr.name, attr.value);
  });
  if (script.src) {
    newScript.src = script.src;
  } else {
    newScript.textContent = script.textContent;
  }
  script.parentNode?.replaceChild(newScript, script);
}